import React from 'react';

import { PanelWithHeader } from '../panels/PanelWithHeader';
import { TasksSummary } from '../todo/TasksSummary';
import { BodyWeightChart } from '../lifestyle/BodyWeightChart';
import { QuickLoansStatistics } from '../loans/QuickLoansStatistics';
import { QuickShoppingList } from '../shopping/QuickShoppingList';

import { PanelWithBreadCrumbAndSearchBox } from '../panels/PanelWithBreadCrumbAndSearchBox';

type GarageHomePageProps = {
    value: string
}

export const GarageHomePage = (props: GarageHomePageProps) => {
    return <div className="container-fluid mt-3">

        <PanelWithBreadCrumbAndSearchBox currentPageName="Dashboard" />
        {  /* <-- ~Heading --> */}

        <div className="row wow fadeIn">

            <div className="col-lg-9 col-md-6 mb-4">

                <PanelWithHeader header="Najeté kilometry" iconClassName="fas fa-running">
                 
                </PanelWithHeader>

            </div>

            <div className="col-lg-3 col-md-6 mb-4">

                <PanelWithHeader header="Seznam úkolů" iconClassName="fas fa-tasks">
      
                </PanelWithHeader>

            </div>

            <div className="col-lg-6 col-md-6 mb-4">
                <PanelWithHeader header="Plánované akce" iconClassName="fas fa-search-dollar">
                    
                </PanelWithHeader>
            </div>

            <div className="col-lg-6 col-md-6 mb-4">
                <PanelWithHeader header="Servisní úkony" iconClassName="fas fa-shopping-cart">
             
                </PanelWithHeader>
            </div>
        </div>
    </div>
}